import React, { Component } from "react";
import AlertSuccess from "../../../common/alertSuccess";
import AlertError from "../../../common/alertError";
import { toast } from "react-toastify";
import { checkOtp, sendOtp } from "../../../../store/patient";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { expiredOTP, invalidOTP } from "../../../common/misc";

class VerifyOtp extends Component {
  state = {
    countDown: 59,
    reset: false,
    countDownId: 1,
    otp: {
      a: "",
      b: "",
      c: "",
      d: "",
    },
    disabledButton: false,
  };
  constructor(props) {
    super(props);
    this.aRef = React.createRef();
    this.bRef = React.createRef();
    this.cRef = React.createRef();
    this.dRef = React.createRef();
  }
  componentDidMount = () => {
    const countDown = setInterval(() => {
      if (this.state.countDown === 1 || this.state.reset)
        clearInterval(countDown);
      this.setState({ countDown: this.state.countDown - 1 });
    }, 1000);
    this.setState({ countDownId: countDown });
  };

  componentWillUnmount() {
    clearInterval(this.state.countDownId);
  }

  onChange = (e) => {
    const { name, value } = e.target;
    const otp = this.state.otp;

    otp[name] = value.replace(/\D/, "");
    if (otp[name] !== "") {
      this.setState({ otp });
      if (name === "a") this.bRef.current.focus();
      if (name === "b") this.cRef.current.focus();
      if (name === "c") this.dRef.current.focus();
      this.setState({ disabledbutton: false });
    } else {
      this.setState({ otp });
    }
  };

  doSubmit = (e) => {
    e.preventDefault();
    const { a, b, c, d } = this.state.otp;
    if (this.state.countDown > 1) {
      this.props.checkOtp(
        { mobile: this.props.verifyMobile.mobile, otp: a + b + c + d },
        this.otpCheckCallback
      );
    } else {
      return toast(<AlertError message={expiredOTP} />);
    }
  };

  otpCheckCallback = (res) => {
    const { a, b, c, d } = this.state.otp;
    const { verifyMobile } = this.props;
    verifyMobile.otp = a + b + c + d;

    if (res.status === 200) {
      const { a, b, c, d } = this.state.otp;
      const { verifyMobile } = this.props;
      verifyMobile.otp = a + b + c + d;
      this.props.updateVerifyMobile(verifyMobile);
      return this.props.history.push(
        "/doctor/sign-up/personal-detail",
        this.props.verifyMobile
      );
    } else {
      this.setState({ disabledButton: true });
      toast(<AlertError message={res.data.error} />);
    }
  };

  reSend = (e) => {
    this.setState({ disabledButton: false });
    clearInterval(this.state.countDownId);
    const param = { mobile: this.props.verifyMobile.mobile, type: "doctor" };
    this.props.sendOtp(param, this.callback);
    e.preventDefault();
  };

  callback = (res) => {
    if (res.status === 200) {
      this.setState({ countDown: 59, reset: true }, () => {
        const countDown = setInterval(() => {
          if (this.state.countDown === 1) clearInterval(countDown);
          this.setState({ countDown: this.state.countDown - 1 });
        }, 1000);

        this.setState({ countDownId: countDown });
      });

      toast(<AlertSuccess message={res.data.otp} />);
      this.props.updateVerifyMobile({
        otp: res.data.otp,
        mobile: this.props.verifyMobile.mobile,
        DOB: this.props.verifyMobile.DOB,
        type: 1,
      });
    } else {
      toast(<AlertError message={res.data.error} />);
    }
  };

  render() {
    return (
      <div className="member-right">
        <div className="member-right-content d-md-flex align-items-center">
          <div className="mr-box">
            <div className="mr-head mb-4">
              <h2>Verify Details</h2>
            </div>
            <form>
              <div className="form-box">
                <div className="enter-otp-box">
                  <p>Please enter OTP sent to phone number</p>
                  <div className="otp-box">
                    <input
                      value={this.state.otp.a}
                      className="form-control"
                      id="codeBox1"
                      type="text"
                      name="a"
                      onChange={this.onChange}
                      maxLength="1"
                      ref={this.aRef}
                    />
                    <input
                      value={this.state.otp.b}
                      className="form-control"
                      id="codeBox2"
                      type="text"
                      name="b"
                      onChange={this.onChange}
                      maxLength="1"
                      ref={this.bRef}
                    />
                    <input
                      value={this.state.otp.c}
                      className="form-control"
                      id="codeBox3"
                      type="text"
                      name="c"
                      onChange={this.onChange}
                      maxLength="1"
                      ref={this.cRef}
                    />
                    <input
                      value={this.state.otp.d}
                      className="form-control"
                      id="codeBox4"
                      type="text"
                      name="d"
                      onChange={this.onChange}
                      maxLength="1"
                      ref={this.dRef}
                    />
                  </div>
                  <div className="time-count">
                    {this.state.countDown > 0
                      ? " Code expires in: "
                      : " Code expired "}
                    <span>
                      {this.state.countDown > 0 &&
                        (this.state.countDown > 9
                          ? "00:" + this.state.countDown
                          : "00:0" + this.state.countDown)}
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <a
                    onClick={this.doSubmit}
                    href=""
                    type="submit"
                    className={
                      this.state.disabledButton
                        ? "btn btn-primary btn-block disabled"
                        : "btn btn-primary btn-block"
                    }
                  >
                    <b className="btn-loader"></b>Verify
                  </a>
                </div>
                <div className="resend-box">
                  <p>
                    Didn't get the code?{" "}
                    <a href="#" onClick={this.reSend}>
                      Resend
                    </a>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  sendOtp: (param, callback) => dispatch(sendOtp(param, callback)),
  checkOtp: (param, callback) => dispatch(checkOtp(param, callback)),
});
export default withRouter(connect(null, mapDispatchToProps)(VerifyOtp));
